module.exports = __webpack_public_path__ + "img/flickr.26da3b7c.svg";